import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { Icon } from 'components/common/icons';

const MultipleChoiceSummary = ({ task }: { task: any }) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="summary">
      <div className="options">
        {task.data && task.data.options
          ? task.data.options.map((option, i) => (
              <div className="option" key={i}>
                <div className="option-content">
                  <div className="option-text">
                    <div
                      className="option-text-inner"
                      dangerouslySetInnerHTML={{ __html: option.text }}
                    />
                  </div>

                  <div className="option-info">
                    <div className="option-percentage">
                      <div className="option-percentage-content">
                        {`${task.optionResponseRates[i]}%`}
                        <div className="option-percentage-indicator">
                          <div
                            className="option-percentage-indicator-fill"
                            style={{ width: `${task.optionResponseRates[i]}%` }}
                          />
                        </div>
                      </div>
                    </div>

                    {task.data.options.some((option) => option.correct) ? (
                      <div className="option-correct">
                        {option.correct ? (
                          <div
                            aria-label={
                              messages.readerMultipleChoiceCorrectOption
                            }
                            data-tooltip={
                              messages.readerMultipleChoiceCorrectOption
                            }
                          >
                            <Icon
                              icon="check"
                              fixedWidth={true}
                              style={{ color: theme.successStandaloneColor }}
                            />
                          </div>
                        ) : (
                          <div
                            aria-label={
                              messages.readerMultipleChoiceIncorrectOption
                            }
                            data-tooltip={
                              messages.readerMultipleChoiceIncorrectOption
                            }
                          >
                            <Icon
                              icon="times"
                              fixedWidth={true}
                              style={{ color: theme.dangerColor }}
                            />
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            ))
          : null}
      </div>

      <style jsx>{`
        .options {
          counter-reset: multiplechoice-option;
        }
        .option {
          background-color: white;
          border-radius: 5px;
          color: ${theme.textColorLight};
          font-size: 1.4rem;
          padding: 8px 10px;
        }
        .option:not(:first-child) {
          margin-top: 10px;
        }
        .option-text {
          display: flex;
          flex-grow: 1;
          flex-shrink: 1;
        }
        .option-text::before {
          counter-increment: multiplechoice-option;
          content: counter(multiplechoice-option, lower-alpha) ')';
          margin-right: 3px;
          width: 12px;
        }
        .option-text-inner {
          word-break: break-word;
        }
        .option-text-inner :global(p) {
          margin: 8px 0 0;
        }
        .option-text-inner :global(p:first-child) {
          margin-top: 0;
        }
        .option-info {
          display: flex;
        }
        .option-correct {
          flex-grow: 1;
          flex-shrink: 0;
          font-size: 1.2rem;
          margin-left: 10px;
          min-width: 0;
          text-align: right;
        }
        .option-percentage {
          margin-left: 10px;
        }
        .option-percentage-content {
          align-items: center;
          background-color: ${theme.lightGrey};
          border-radius: 4px;
          display: flex;
          font-size: 1.2rem;
          font-weight: 600;
          padding: 1px 5px;
          white-space: nowrap;
        }
        .option-percentage-indicator {
          background-color: ${theme.lightGreyDark};
          border-radius: 3px;
          display: inline-block;
          height: 6px;
          margin-left: 5px;
          overflow: hidden;
          width: 50px;
        }
        @keyframes optionPercentageFill {
          0% {
            width: 0;
          }
        }
        .option-percentage-indicator-fill {
          animation: optionPercentageFill 1s;
          background-color: rgba(0, 0, 0, 0.4);
          height: 100%;
        }
        @media (max-width: ${breakpoints.small - 1}px) {
          .option-info {
            margin-top: 10px;
          }
        }
        @media (min-width: ${breakpoints.small}px) {
          .option-content {
            display: flex;
          }
        }
      `}</style>
    </div>
  );
};

export default MultipleChoiceSummary;
